/**
 * Genera un Code 128 (subset B) como data URL PNG — sin dependencias extra
 */
const CODE128_B_START = 104
const CODE128_STOP = 106

/** Patrones Code 128 (barras/espacios) indexados 0–106 */
const CODE128_PATTERNS: string[] = [
  '212222','222122','222221','121223','121322','131222','122213','122312','132212','221213',
  '221312','231212','112232','122132','122231','113222','123122','123221','223211','221132',
  '221231','213212','223112','312131','311222','321122','321221','312212','322112','322211',
  '212123','212321','232121','111323','131123','131321','112313','132113','132311','211313',
  '231113','231311','112133','112331','132131','113123','113321','133121','313121','211331',
  '231131','213113','213311','213131','311123','311321','331121','312113','312311','332111',
  '314111','221411','431111','111224','111422','121124','121421','141122','141221','112214',
  '112412','122114','122411','142112','142211','241211','221114','413111','241112','134111',
  '111242','121142','121241','114212','124112','124211','411212','421112','421211','212141',
  '214121','412121','111143','111341','131141','114113','114311','411113','411311','113141',
  '114131','311141','411131','211412','211214','211232','2331112',
]

function charToCode128B(char: string): number {
  const code = char.charCodeAt(0)
  if (code < 32 || code > 127) {
    throw new Error(`Carácter no soportado en Code128B: ${char}`)
  }
  return code - 32
}

function encodeCode128B(text: string): number[] {
  const codes = [CODE128_B_START]
  let checksum = CODE128_B_START

  for (let i = 0; i < text.length; i += 1) {
    const value = charToCode128B(text[i])
    codes.push(value)
    checksum += value * (i + 1)
  }

  codes.push(checksum % 103)
  codes.push(CODE128_STOP)
  return codes
}

/**
 * Dibuja barcode Code128B y retorna data URL PNG
 */
export function generateCode128DataUrl(
  text: string,
  options?: { width?: number; height?: number }
): string {
  const clean = String(text || '').trim()
  if (!clean) {
    return ''
  }

  const width = options?.width ?? 250
  const height = options?.height ?? 30

  const codes = encodeCode128B(clean)
  let modules = 0
  codes.forEach((code) => {
    const pattern = CODE128_PATTERNS[code]
    for (let i = 0; i < pattern.length; i += 1) {
      modules += Number(pattern[i])
    }
  })

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  if (!ctx) return ''

  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, width, height)
  ctx.fillStyle = '#000000'

  const moduleWidth = width / modules
  let x = 0
  let drawBar = true

  codes.forEach((code) => {
    const pattern = CODE128_PATTERNS[code]
    for (let i = 0; i < pattern.length; i += 1) {
      const w = Number(pattern[i]) * moduleWidth
      if (drawBar) {
        ctx.fillRect(x, 0, w, height)
      }
      x += w
      drawBar = !drawBar
    }
  })

  return canvas.toDataURL('image/png')
}
